import React from "react";

/**
 * Loading skeleton component to prevent CLS
 * Reserves space for dynamically loaded components
 */
export const SectionSkeleton: React.FC<{ height?: string }> = ({
  height = "400px",
}) => {
  return (
    <div
      className="w-full bg-gray-50 animate-pulse"
      style={{
        minHeight: height,
        contain: "layout style paint",
      }}
      aria-label="Loading content..."
    >
      <div className="main_container mx-auto py-10 lg:py-16">
        <div className="h-8 bg-gray-200 rounded w-1/3 mb-6"></div>
        <div className="h-4 bg-gray-200 rounded w-2/3 mb-4"></div>
        <div className="h-4 bg-gray-200 rounded w-1/2"></div>
      </div>
    </div>
  );
};

/**
 * Minimal loading placeholder that reserves exact space
 */
export const MinimalSkeleton: React.FC<{ height?: string }> = ({
  height = "200px",
}) => {
  return (
    <div
      style={{
        minHeight: height,
        contain: "layout style paint",
        visibility: "hidden",
      }}
      aria-hidden="true"
    />
  );
};

export default SectionSkeleton;
